import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { tk } from '@/i18n/translationKeys';
import { Button } from '@getgrover/ui';
import { TrackYourPaymentsEvents } from '@/analytics';
import { useApplicationData } from '@/providers/applicationData';
import { useScreenMatch } from '@/hooks/useScreenMatch';
import { Group } from '@/components/Group';
import { WalletIcon } from '@/icons/WalletIcon';

import { LinkToPaymentMethodsRoot } from './LinkToPaymentMethods.styles';

export const LinkToPaymentMethods = () => {
  const { userId, storeCode, routeBuilder } = useApplicationData();
  const { t } = useTranslation();
  const { isMobile } = useScreenMatch();

  const handleClick = useCallback(() => {
    TrackYourPaymentsEvents.paymentMethodsLinkClick({
      userId,
      store: storeCode,
    });

    window.location.href = routeBuilder.buildPaymentMethodListRoute();
  }, [storeCode]);

  return (
    <LinkToPaymentMethodsRoot
      onClick={handleClick}
      data-testid="your-payments-manage-payment-methods-button"
    >
      {isMobile ? (
        <div>
          <WalletIcon />
        </div>
      ) : (
        <Button size="S" variant="Grey">
          <WalletIcon />
          {t(tk.yourPaymentsLinkToPaymentMethodsText)}
        </Button>
      )}
    </LinkToPaymentMethodsRoot>
  );
};
